import {
    SearchComponentEnum,
    SearchComponentGroup,
    SearchComponentOfGroup,
    SearchComponentOfType,
    SearchComponentType
} from "@/utils/search/types/searchComponent";

const SEARCH_COMPONENT_SEPARATOR = "_";

const getComponentGroup: (
    component: SearchComponentEnum
) => SearchComponentGroup | null = (component) => {
    const separatorIndex = component.indexOf(SEARCH_COMPONENT_SEPARATOR);
    return separatorIndex > -1
        ? (component.slice(0, separatorIndex) as SearchComponentGroup)
        : null;
};

const getComponentType: (
    component: SearchComponentEnum
) => SearchComponentType | null = (component) => {
    const separatorIndex = component.indexOf(SEARCH_COMPONENT_SEPARATOR);
    return separatorIndex > -1
        ? (component.slice(separatorIndex + 1) as SearchComponentType)
        : null;
};

const createSearchComponentEnum = (
    group: SearchComponentGroup,
    type: SearchComponentType
) => `${group}${SEARCH_COMPONENT_SEPARATOR}${type}` as SearchComponentEnum;

const createTypeInGroup = (
    component: SearchComponentEnum,
    type: SearchComponentType
) => {
    const group = getComponentGroup(component);
    if (!group) return;

    return createSearchComponentEnum(group, type);
};

const isGroup = <
    TComponent extends {
        component: SearchComponentOfType<SearchComponentType>;
    },
    TGroup extends SearchComponentGroup
>(
    component: TComponent,
    componentGroup: TGroup
): component is Extract<
    TComponent,
    { component: SearchComponentOfGroup<TGroup> }
> => {
    return getComponentGroup(component.component) === componentGroup;
};

const isType = <
    TComponent extends {
        component: SearchComponentOfType<SearchComponentType>;
    },
    TType extends SearchComponentType
>(
    component: TComponent,
    componentType: TType
): component is Extract<
    TComponent,
    { component: SearchComponentOfType<TType> }
> => {
    return getComponentType(component.component) === componentType;
};

export {
    createSearchComponentEnum,
    createTypeInGroup,
    getComponentGroup,
    getComponentType,
    isGroup,
    isType
};
